import { DrawerOverlay as ChakraDrawerOverlay } from '@chakra-ui/react';
import React from 'react';

const DrawerOverlay = (): React.ReactElement => {
  return <ChakraDrawerOverlay />;
};

export default DrawerOverlay;
